export { CustomIconExtension } from './custom-icon.extension';
